<template>
	<div v-if="showLanguageBtn" :class="buttonClass" @click="handleLangChange">
		<!-- PC版本 -->
		<template v-if="mode === 'pc'">
			<SvgIcons :name="languageIcon" class="c-action-svg" />
			<span class="action-block-span">{{ languageLabel }}</span>
		</template>

		<!-- 移动端版本 -->
		<template v-else>
			<img :src="getMobLangImg" alt="" />
		</template>
	</div>
</template>

<script setup>
import { computed, inject, onMounted, ref } from 'vue';
import { useLanguageSwitch } from '../hooks/useLanguageSwitch.js';
import i18n, { EN, ZH, ZH_HK } from '@/locales';
import I18_EN_ICON from '@/assets/images/i18-en.png';
import I18_CN_ICON from '@/assets/images/i18-zh-cn.png';
import I18_HK_ICON from '@/assets/images/i18-zh-hk.png';

const mode = inject('mode');
const buttonClass = inject('normalButtonClass');

const { showLanguageBtn, handleLangChange } = useLanguageSwitch();

const languageMap = {
	// 展示另一个语言版本的内容
	[EN]: {
		label: '简体中文',
		icon: 'icon_cn',
		mobIcon: I18_CN_ICON
	},
	[ZH]: {
		label: 'English',
		icon: 'icon_en',
		mobIcon: I18_EN_ICON
	},
	// 兜底
	[ZH_HK]: {
		label: '繁體中文',
		icon: 'icon_hk',
		mobIcon: I18_HK_ICON
	}
};

// PC端语言图标 & 文案
const languageIcon = ref('');
const languageLabel = ref('');

const initActionLang = val => {
	languageIcon.value = languageMap[val].icon;
	languageLabel.value = languageMap[val].label;
};
onMounted(() => {
	initActionLang(i18n.locale);
});

const getMobLangImg = computed(() => {
	return languageMap[i18n.locale].mobIcon;
});
</script>
